import { Link } from 'react-router-dom'
import { flattenNav } from '../nav'

interface Props {
  currentSlug: string
  max?: number
}

export default function RelatedPages({ currentSlug, max = 3 }: Props) {
  const all = flattenNav()
  const current = all.find((leaf) => leaf.slug === currentSlug)
  if (!current) return null

  // Same-category siblings first, then fill from other categories. Today the
  // v1 pages are all single-category so this collapses to "first N others",
  // but it does the right thing once we add sub-pages inside each category.
  const sameCategory = all.filter(
    (leaf) => leaf.slug !== currentSlug && leaf.category === current.category,
  )
  const otherCategory = all.filter(
    (leaf) => leaf.slug !== currentSlug && leaf.category !== current.category,
  )
  const related = [...sameCategory, ...otherCategory].slice(0, max)
  if (related.length === 0) return null

  return (
    <aside className="related" aria-label="Related pages">
      <p className="related-title">Keep reading</p>
      <div className="related-grid">
        {related.map((leaf) => (
          <Link key={leaf.slug} to={leaf.slug} className="card">
            <p className="card-title">{leaf.title}</p>
            <p className="card-body">{leaf.description}</p>
          </Link>
        ))}
      </div>
    </aside>
  )
}
